import { isWeb } from "@stepapp/core";
import { Block, Loader } from "@stepapp/ui";
import { useGlobalSearchParams, useLocalSearchParams, useRouter } from "expo-router";
import { useEffect, useMemo } from "react";
import { useIsNavReady, useServiceNavigation } from "../../../src/hooks";

const DefaultScreen = () => {
  const { replace } = useRouter();
  const isNavReady = useIsNavReady();
  const localParams = useLocalSearchParams<{ slug: string }>();
  const params = useGlobalSearchParams<{ [key: string]: string }>();

  const slug = useMemo(() => localParams?.slug || params?.slug, [localParams?.slug, params?.slug]);

  const { loading, platformSegments } = useServiceNavigation(slug);

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useEffect(() => {
    if (!isNavReady || loading) return;

    if (isWeb) {
      return replace(`/service/${slug}/configure`);
    }

    replace(`/service/${slug}/${platformSegments[0]}`);
  }, [isNavReady, loading]);

  return (
    <Block alignCenter justifyCenter height={30}>
      <Loader />
    </Block>
  );
};

export default DefaultScreen;
